/*
 * @Author: 小周
 * @Date: 2023-09-06 17:56:59
 * @LastEditTime: 2023-09-07 10:40:42
 * @LastEditors: MrZHLF 480970024@qq.com
 * @Description: redux配置项
 */

import { configureStore } from '@reduxjs/toolkit'

import userReducer from './reducer/userReducer'

export default configureStore({
  reducer: {
    user: userReducer,
  },
})
